class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.updateURL();
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {

    const variants = window.variants;
    const product_data = JSON.parse(document.querySelector("[data-product]").textContent);

    let actualColor;

    if(!this.currentVariant){
      actualColor = this.options[0];
    }else{
      actualColor = variants.filter(variant => variant.id == this.currentVariant.id)[0].option1;
    }

    const activeVariantColor = variants.find(variant => variant.option1 == actualColor);

    let allVariantsColor = [activeVariantColor];

    variants.forEach(variant => {
      if(variant.option1 !== actualColor && !allVariantsColor.some(v => v.option1 == variant.option1)){
        allVariantsColor = [...allVariantsColor, variant]
      }
    })

    const swiperTop = document.querySelector(".gallery-top");
    swiperTop.swiper.destroy();

    const swiperThumbs = document.querySelector(".gallery-thumbs");
    swiperThumbs.swiper.destroy();

    const wrapperTop = swiperTop.querySelector(".swiper-wrapper");
    wrapperTop.removeAttribute("style");
    wrapperTop.innerHTML = "";

    const wrapperThumbs = swiperThumbs.querySelector(".swiper-wrapper");
    wrapperThumbs.removeAttribute("style");
    wrapperThumbs.innerHTML = "";
    
    if(!product_data.options.includes("Supply")){

      allVariantsColor.forEach(variant => {
        wrapperThumbs.appendChild(this.swiperHTML2(variant.featured_media,variant.id));
      });

    }else{
      wrapperThumbs.appendChild(this.swiperHTML2(allVariantsColor[0].featured_media,allVariantsColor[0].id));
    }

    if(!product_data.options.includes("Supply")){
      allVariantsColor.forEach(variant => {
        wrapperTop.appendChild(this.swiperHTML1(variant.featured_media,variant.id));
      });
    }else{
      wrapperTop.appendChild(this.swiperHTML1(allVariantsColor[0].featured_media,allVariantsColor[0].id));
    }



    var galleryThumbs = new Swiper('.gallery-thumbs', {
      slidesPerView: 3,
      spaceBetween: 10,
      loop: false,
      direction: 'horizontal',
      navigation: {
        nextEl: '.swiper-button-next-thumb',
        prevEl: '.swiper-button-prev-thumb'
      },
      breakpoints: {
         1080: {
          direction: 'vertical'
        }
      }
    });

    galleryThumbs.on("realIndexChange",e => {

      this.toggleAddButton(false,"",false);

      if(!e.isEnd && !e.isBeginning){
        const arrowLeft = document.querySelector(".swiper-button-prev-thumb svg");
        const arrowRight = document.querySelector(".swiper-button-next-thumb svg");
        arrowLeft.classList.remove("hidden");
        arrowRight.classList.remove("hidden");
      }
  
    });
  
    galleryThumbs.on("reachEnd",() => {
      const arrowRight = document.querySelector(".swiper-button-next-thumb svg");
      const arrowLeft = document.querySelector(".swiper-button-prev-thumb svg");
      arrowRight.classList.add("hidden");
      arrowLeft.classList.remove("hidden");
    });
  
    galleryThumbs.on("reachBeginning",() => {
      const arrowLeft = document.querySelector(".swiper-button-prev-thumb svg");
      const arrowRight = document.querySelector(".swiper-button-next-thumb svg");
      arrowLeft.classList.add("hidden");
      arrowRight.classList.remove("hidden");
    });
      
    var galleryTop = new Swiper(swiperTop, {
      slidesPerView: 1,
      loop: false,
      spaceBetween: 0,
      pagination: {
        el: ".swiper-pagination"
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });

    galleryTop.on("slideChange", e => {

      const slide = e.slides[e.activeIndex];
      const id = slide.dataset.variantId;
      const actualVariant = window.variants.filter(variant => variant.id == id );
      const actualColor = actualVariant[0].option1;
  
      const selectColor = document.querySelector(".select-color");
      const options = selectColor.querySelectorAll("option");
  
      options.forEach( option => {  
        if(option.value == actualColor) {
          option.selected = true;
        }
      })

      const thumbsSlider = document.querySelector(".gallery-thumbs");
      const thumbsSlider_slides = thumbsSlider.querySelectorAll(".swiper-slide");
  
      thumbsSlider_slides.forEach(slide => {
  
        if(slide.dataset.variantId == id){
  
          const indexText = slide.getAttribute("aria-label");
          const index = Number(indexText.split("/")[0].trim()) - 1;
          galleryThumbs.slideTo(index,1000,false)
  
        }
  
      })

      const sectionId = galleryTop.$el[0].dataset.sectionId;
      const actualColorForm = document.querySelector(`#Option-${sectionId}-0`).value;
      const actualSizeForm = document.querySelector(`#Option-${sectionId}-1`);
      let exist_variant;
      const addButton = document.getElementById(`product-form-${sectionId}`)?.querySelector('[name="add"]');    
  
      if(actualSizeForm){
        exist_variant = window.variants.find( variant => variant.option1 == actualColorForm && variant.option2 == actualSizeForm.value)
      }else{
        exist_variant = window.variants.find( variant => variant.option1 == actualColorForm)
      }
  
      if(!exist_variant){
        addButton.textContent = window.variantStrings.unavailable;
        addButton.setAttribute('disabled', true);
        document.getElementById(`price-${sectionId}`)?.classList.add('hidden');
      }else{
        document.getElementById(`price-${sectionId}`)?.classList.remove('hidden');
        addButton.removeAttribute('disabled');
        addButton.textContent = window.variantStrings.addToCart;
      }
  
    });

    let gallerySlides = document.querySelectorAll('.gallery-thumbs .swiper-slide')
    gallerySlides.forEach(element => {
      
      element.addEventListener('click',function(e) {
        e.preventDefault();
        e.stopPropagation();
        let indexClicked = Array.from(this.parentNode.children).indexOf(this)
        console.log(indexClicked);
        const slider_top_wrapper_count = document.querySelector(".gallery-top .swiper-wrapper").children.length;
        const className_to_find = `.gallery-top .swiper-slide[aria-label="${indexClicked+1} / ${slider_top_wrapper_count}"]`
        console.log(className_to_find);
        let elementSlide = document.querySelector(className_to_find);
        console.log(elementSlide);
        let indexSlide =Array.from(elementSlide.parentNode.children).indexOf(elementSlide)
        galleryTop.slideTo(indexSlide, 1000, false)
        e.preventDefault();
        e.stopPropagation();
      })
  
    });

    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);

  }

  swiperHTML1(product,id) {
    
    const swiperSlide = document.createElement("DIV");
    swiperSlide.classList.add("swiper-slide","color-accent-1");
    swiperSlide.dataset.variantId = id;
    swiperSlide.innerHTML = `

      <noscript>

        <div class="product__media media" style="padding-top: ${1/product.preview_image.aspect_ratio*100}%;">
          <img
            src="${product.preview_image.src}"
            sizes="(min-width: 1200px) calc((1200px - 10rem) / 2), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)"
            loading="lazy"
            width="576"
            height="${576/product.preview_image.aspect_ratio}"
            alt="${product.alt}"
          >
        </div>

      </noscript>

      <modal-opener class="product__modal-opener product__modal-opener--image no-js-hidden" data-modal="${window.data_modal_pdp}">

        <span class="product__media-icon motion-reduce" aria-hidden="true">

          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-plus" width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4.66724 7.93978C4.66655 7.66364 4.88984 7.43922 5.16598 7.43853L10.6996 7.42464C10.9758 7.42395 11.2002 7.64724 11.2009 7.92339C11.2016 8.19953 10.9783 8.42395 10.7021 8.42464L5.16849 8.43852C4.89235 8.43922 4.66793 8.21592 4.66724 7.93978Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.92576 4.66463C8.2019 4.66394 8.42632 4.88723 8.42702 5.16337L8.4409 10.697C8.44159 10.9732 8.2183 11.1976 7.94215 11.1983C7.66601 11.199 7.44159 10.9757 7.4409 10.6995L7.42702 5.16588C7.42633 4.88974 7.64962 4.66532 7.92576 4.66463Z" fill="currentColor"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.8324 3.03011C10.1255 0.323296 5.73693 0.323296 3.03011 3.03011C0.323296 5.73693 0.323296 10.1256 3.03011 12.8324C5.73693 15.5392 10.1255 15.5392 12.8324 12.8324C15.5392 10.1256 15.5392 5.73693 12.8324 3.03011ZM2.32301 2.32301C5.42035 -0.774336 10.4421 -0.774336 13.5395 2.32301C16.6101 5.39361 16.6366 10.3556 13.619 13.4588L18.2473 18.0871C18.4426 18.2824 18.4426 18.599 18.2473 18.7943C18.0521 18.9895 17.7355 18.9895 17.5402 18.7943L12.8778 14.1318C9.76383 16.6223 5.20839 16.4249 2.32301 13.5395C-0.774335 10.4421 -0.774335 5.42035 2.32301 2.32301Z" fill="currentColor"/>
          </svg>

        </span>

        <div class="product__media media" style="padding-top: ${1/product.preview_image.aspect_ratio*100}%;">
          <img
            src="${product.preview_image.src}"
            sizes="(min-width: 1200px) calc((1200px - 10rem) / 2), (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)"
            loading="lazy"
            width="576"
            height="${576/product.preview_image.aspect_ratio}"
            alt="${product.alt}"
          >
        </div>
        
        <button class="product__media-toggle" type="button" aria-haspopup="dialog" data-media-id="${product.id}">
          <span class="visually-hidden">
            Open featured media in gallery view
          </span>
        </button>

      </modal-opener>

    `;

    return swiperSlide;

  }

  swiperHTML2(product,id) {

    const swiperSlide = document.createElement("DIV");
    swiperSlide.classList.add("swiper-slide","color-accent-1");
    swiperSlide.dataset.variantId = id;
    swiperSlide.innerHTML = `
      <img
        sizes="(min-width: 750px) 25vw, 50vw, 100vw"
        src="${product.preview_image.src}"
        loading="lazy"
        alt="${product.alt}"
        width="${product.preview_image.width}"
        height="${product.preview_image.height}"
      >

    `
    return swiperSlide;
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);
